import script from "./PersonSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./PersonSelector.vue?vue&type=script&lang=ts&setup=true"

import "./PersonSelector.vue?vue&type=style&index=0&id=aec7e926&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aec7e926"]])

export default __exports__